import axios from '../axios-auth'

export const counterCashService = {
    getCounterCashList,
    getCounterCashDetail,
    saveCounterCash,
    getCounterCashSummary,
    getCounterCashSummaryDetailList,
    getAllCounterCashList
};

function getCounterCashList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.cashType) {
        params["cashType"] = searchParams.cashType;
    }
    if (searchParams.counterId) {
        params["counterId"] = searchParams.counterId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }
    return axios.get("/auth/counter-cashs", { params });
}

function getAllCounterCashList(searchParams) {
    let params = {};

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.cashType) {
        params["cashType"] = searchParams.cashType;
    }
    if (searchParams.counterId) {
        params["counterId"] = searchParams.counterId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }

    return axios.get("/auth/counterCashSummaryDetail", { params });
}
function getCounterCashDetail(id) {
    return axios.get('/auth/counter-cash/' + id);
}

function saveCounterCash(counterCash) {
    if (counterCash.id) {
        //edit
        return axios.put('/auth/counter-cash', counterCash);
    }
    else {
        // create new
        return axios.post('/auth/counter-cash', counterCash);
    }

}

function getCounterCashSummary(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.cashType) {
        params["cashType"] = searchParams.cashType;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.counterId) {
        params["counterId"] = searchParams.counterId;
    }
    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }

    return axios.get("/auth/counterCashSummary", { params });
}

function getCounterCashSummaryDetailList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.cashType) {
        params["cashType"] = searchParams.cashType;
    }
    if (searchParams.counterId) {
        params["counterId"] = searchParams.counterId;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }

    return axios.get("/auth/counterCashSummaryDetail", { params });
}
